import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_2 = { class: "d-flex justify-content-end" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "d-flex flex-wrap" };
const _hoisted_6 = {
    class: "modal fade",
    id: "create",
    tabindex: "-1",
    "aria-labelledby": "createModalLabel",
    "aria-hidden": "true"
};
const _hoisted_7 = { class: "modal-dialog modal-dialog-centered modal-lg" };
const _hoisted_8 = { class: "modal-content" };
const _hoisted_9 = { class: "modal-body" };
const _hoisted_10 = { class: "form-floating mb-3" };
const _hoisted_11 = { class: "form-floating mb-3" };
const _hoisted_12 = { class: "input-group mb-3" };
const _hoisted_13 = { class: "form-floating" };
const _hoisted_14 = { class: "form-floating mb-3" };
const _hoisted_15 = {
    class: "modal fade",
    id: "standardPackage",
    tabindex: "-1",
    "aria-labelledby": "standardPackageLabel",
    "aria-hidden": "true"
};
const _hoisted_16 = { class: "modal-dialog modal-dialog-centered modal-lg" };
const _hoisted_17 = { class: "modal-content" };
const _hoisted_18 = { class: "modal-body" };
const _hoisted_19 = { class: "row" };
const _hoisted_20 = { class: "col-12 col-lg-6 d-flex align-items-center" };
const _hoisted_21 = { class: "w-100 form-floating mb-3" };
const _hoisted_22 = { class: "col-12 col-lg-6" };
const _hoisted_23 = ["src"];
import { FilterMatchMode } from '@primevue/core/api';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, Link, useForm } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import YesNoIcon from '@/Shared/YesNoIcon.vue';
import { responseMessages } from '@/Composables/responseMessages';
import TinyEditor from '@/Components/TinyEditor.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Index',
    props: {
        packages: Object,
        standardPackageImage: {
            type: String,
            required: false
        }
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        onMounted(() => {
        });
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const createPackageForm = useForm({
            artNo: null,
            name: null,
            description: null,
            weight: null,
            maxProductsAmount: null
        });
        const updateStandardPackageForm = useForm({
            newImage: null,
            imageFilePath: props.standardPackageImage
        });
        function createPackage() {
            createPackageForm.transform((data) => ({
                art_no: data.artNo,
                name: data.name,
                description: data.description,
                weight: data.weight,
                max_products_amount: data.maxProductsAmount
            })).submit('post', route('admin.packages.store'), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    createPackageForm.reset();
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function updateStandardPackage() {
            updateStandardPackageForm.transform((data) => ({
                image_file: data.newImage,
            }))
                .submit('post', route('admin.tenantSettings.updateStandardPackage'), {
                preserveScroll: true,
                onSuccess: page => {
                    updateStandardPackageForm.reset();
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Verpackungen" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _cache[13] || (_cache[13] = _createElementVNode("h1", { class: "fw-bold mb-3" }, "Verpackungen", -1)),
                        _createElementVNode("div", _hoisted_1, [
                            _cache[11] || (_cache[11] = _createElementVNode("button", {
                                class: "btn btn-secondary d-inline-flex align-items-center me-3",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#create"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    class: "bi bi-plus-lg",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                    })
                                ]),
                                _createElementVNode("span", { class: "ms-2" }, "Neue Verpackung")
                            ], -1)),
                            _cache[12] || (_cache[12] = _createElementVNode("button", {
                                class: "btn btn-primary d-inline-flex align-items-center",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#standardPackage"
                            }, "Standard-Verpackung", -1)),
                            _createVNode(_unref(DataTable), {
                                dataKey: "id",
                                value: props.packages,
                                stripedRows: "",
                                responsiveLayout: "scroll",
                                globalFilterFields: ['artNo', 'name', 'weight', 'maxProductsAmount', 'createdAt', 'updatedAt'],
                                filters: tableFilter.value,
                                "onUpdate:filters": _cache[1] || (_cache[1] = ($event) => ((tableFilter).value = $event)),
                                paginator: true,
                                rows: 10,
                                paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                                rowsPerPageOptions: [10, 25, 50, 150],
                                currentPageReportTemplate: "{first} von {last} von insgesamt {totalRecords}"
                            }, {
                                header: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tableFilter.value['global'].value) = $event)),
                                            placeholder: "Suche",
                                            style: { "width": "250px" }
                                        }, null, 512), [
                                            [_vModelText, tableFilter.value['global'].value]
                                        ])
                                    ])
                                ]),
                                empty: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                        _createElementVNode("div", { class: "p-3" }, " Keine Einträge gefunden ", -1)
                                    ]))]),
                                loading: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                        _createTextVNode(" Einträge werden geladen ... ", -1)
                                    ]))]),
                                default: _withCtx(() => [
                                    _createVNode(_unref(Column), {
                                        header: "#",
                                        sortable: true
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "artNo",
                                        header: "Artnr.",
                                        sortable: true,
                                        sortField: "artNo"
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Name",
                                        sortable: true,
                                        sortField: "name"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createVNode(_unref(Link), {
                                                href: _ctx.route('admin.packages.edit', slotProps.data.uuid)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(slotProps.data.name), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["href"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "weight",
                                        header: "Gewicht (g)",
                                        sortable: true,
                                        sortField: "weight"
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "maxProductsAmount",
                                        header: "Max. Produkt-Anzahl",
                                        sortable: true,
                                        sortField: "maxProductsAmount"
                                    }),
                                    _createVNode(_unref(Column), { header: "Preis-Range" }, {
                                        body: _withCtx((slotProps) => [
                                            (slotProps.data.startPrice != slotProps.data.endPrice)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(formatCurrency)(slotProps.data.startPrice)) + " - " + _toDisplayString(_unref(formatCurrency)(slotProps.data.endPrice)), 1))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(formatCurrency)(slotProps.data.startPrice)), 1))
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Aktiv",
                                        sortable: true,
                                        sortField: "active"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createVNode(YesNoIcon, {
                                                answer: slotProps.data.active
                                            }, null, 8, ["answer"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Letzte Änderung",
                                        sortable: true,
                                        sortField: "updatedAt"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.updatedAt, true)), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Erstellt",
                                        sortable: true,
                                        sortField: "createdAt"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.createdAt, true)), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), { header: "" }, {
                                        body: _withCtx((slotProps) => [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createVNode(_unref(Link), {
                                                    href: _ctx.route('admin.packages.edit', slotProps.data.uuid),
                                                    class: "btn btn-primary d-inline-flex align-items-center"
                                                }, {
                                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "16",
                                                                height: "16",
                                                                fill: "currentColor",
                                                                class: "bi bi-pencil-square text-white",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
                                                                _createElementVNode("path", {
                                                                    "fill-rule": "evenodd",
                                                                    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                                                })
                                                            ], -1)
                                                        ]))]),
                                                    _: 1
                                                }, 8, ["href"])
                                            ])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["value", "filters"])
                        ])
                    ]),
                    _: 1
                }),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", {
                                        class: "modal-title fs-5 fw-bold",
                                        id: "createModalLabel"
                                    }, "Neue Verpackung"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(createPackage, ["prevent"])
                                }, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "artNo",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(createPackageForm).artNo) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(createPackageForm).artNo]
                                            ]),
                                            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "artNo" }, "Artnr.", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "name",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(createPackageForm).name) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(createPackageForm).name]
                                            ]),
                                            _cache[15] || (_cache[15] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("div", _hoisted_13, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    class: "form-control",
                                                    min: "0",
                                                    step: "0.01",
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(createPackageForm).weight) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(createPackageForm).weight]
                                                ]),
                                                _cache[16] || (_cache[16] = _createElementVNode("label", { for: "weight" }, "Gewicht", -1))
                                            ]),
                                            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "input-group-text" }, "g", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "maxProductsAmount",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(createPackageForm).maxProductsAmount) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(createPackageForm).maxProductsAmount]
                                            ]),
                                            _cache[18] || (_cache[18] = _createElementVNode("label", { for: "maxProductsAmount" }, "Max. Produkt-Anzahl pro Verpackung", -1))
                                        ]),
                                        _createElementVNode("div", null, [
                                            _cache[19] || (_cache[19] = _createElementVNode("label", {
                                                for: "description",
                                                class: "mb-2"
                                            }, "Beschreibung", -1)),
                                            _createVNode(TinyEditor, {
                                                id: "description",
                                                modelValue: _unref(createPackageForm).description,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(createPackageForm).description) = $event)),
                                                height: 300
                                            }, null, 8, ["modelValue"])
                                        ])
                                    ]),
                                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            "data-bs-dismiss": "modal"
                                        }, "Abbrechen"),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ])
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", {
                                        class: "modal-title fs-5 fw-bold",
                                        id: "standardPackageLabel"
                                    }, "Standard-Verpackung"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(updateStandardPackage, ["prevent"]),
                                    enctype: "multipart/form-data"
                                }, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("div", _hoisted_20, [
                                                _createElementVNode("div", _hoisted_21, [
                                                    _createElementVNode("input", {
                                                        type: "file",
                                                        onInput: _cache[7] || (_cache[7] = ($event) => (_unref(updateStandardPackageForm).newImage = $event.target.files[0])),
                                                        class: "form-control",
                                                        id: "newMailLogoFile"
                                                    }, null, 32),
                                                    _cache[22] || (_cache[22] = _createElementVNode("label", { for: "newMailLogoFile" }, "Neues Produktbild", -1))
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_22, [
                                                (_unref(updateStandardPackageForm).imageFilePath)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: _unref(updateStandardPackageForm).imageFilePath,
                                                        class: "img-fluid rounded mb-3",
                                                        alt: "Firmen-Logo"
                                                    }, null, 8, _hoisted_23))
                                                    : _createCommentVNode("", true),
                                                _cache[23] || (_cache[23] = _createElementVNode("p", { class: "form-text" }, "Aktuelles Produktbild", -1))
                                            ])
                                        ])
                                    ]),
                                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            "data-bs-dismiss": "modal"
                                        }, "Abbrechen"),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ])
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ])
                ]))
            ], 64));
        };
    }
});
